export const OPTHINES = {
  voteName: '2020project/2020calligraphy',
  number: {
    mustRank: true,
  },
  themeColor: {
    activeBgColor: '#C660BE',
    inactiveBgColor: '#C660BE',
  },
  tabs: [
    {
      tabName: '返回首页',
      tabPath: '/20200917ZJBPrize/First',
    },
  ],
};
